module.exports = __webpack_public_path__ + "img/limit-his-land-1.1e8b6001.jpg";